var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferenceIconWhite = function SvgReferenceIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "var(--neutral-white)"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Reference_Icon_White_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Reference_Icon_White_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 9.75v-1.5h4.5v1.5zm5.063-2.887L4.238 5.287l1.05-1.05 1.574 1.576zM8.25 5.25V.75h1.5v4.5zm3.938 1.612-1.05-1.05 1.575-1.575 1.05 1.05zm.562 2.888v-1.5h4.5v1.5zM9 11.25a2.17 2.17 0 0 1-1.594-.656A2.17 2.17 0 0 1 6.75 9q0-.937.656-1.594A2.17 2.17 0 0 1 9 6.75a2.17 2.17 0 0 1 1.594.656q.656.657.656 1.594a2.17 2.17 0 0 1-.656 1.594A2.17 2.17 0 0 1 9 11.25m3.713 2.512-1.575-1.575 1.05-1.05 1.574 1.576zm-7.425 0-1.05-1.05 1.574-1.575 1.05 1.05zM8.25 17.25v-4.5h1.5v4.5z"
  }))));
};
export default SvgReferenceIconWhite;